<template lang="pug">
pr-wrapper.flex.flex-col(fs, bg, :bgo="nolayout ? '1' : '0'") 
  img.software(v-show="nolayout", src="@/assets/images/software.png")
  img.company(v-show="nolayout", src="@/assets/images/digital_signage.png")
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "digital-signage",
  data() {
    return {
      signage: null,
      duration: null,
      timeouts: [],
      nolayout: false
    }
  },
  computed: {
    getSignageModel() {
      return {
        distribution: null,
        start: null,
        layouts: [],
        layout: null
      }
    },
    ...mapState(["config", "guest", "menus", "device"])
  },
  watch: {
    signage(nval, oval) {
      if (!oval) oval = {}

      const isChanged = (array1, array2) => array1.every((item, index) => JSON.stringify(item) === JSON.stringify(array2[index]))
      if (isChanged(Object.values(nval), Object.values(oval))) return
      if (!nval.distribution || !nval.layouts) return this.reset("default")

      if (nval.distribution !== oval.distribution || nval.layout !== oval.layout || JSON.stringify(nval.layouts) !== JSON.stringify(oval.layouts))
        return __.platform.background().then(() => this.init())
    }
  },
  activated() {
    window.DS = this
    this.checker(0)
    _$.vue.$on(["mediaError", "mediaEnded"], this.streamHandler)
  },
  deactivated() {
    _$.vue.$off(["mediaError", "mediaEnded"], this.streamHandler)
  },
  methods: {
    async streamHandler() {
      if (!this.signage.layouts.length || this.signage.layouts.length > 1) return

      const layout_ = _$.clone(this.signage.layouts[0])
      if (layout_.type !== "stream" || (!layout_.url?.startsWith("http") && !layout_.url?.startsWith("hls"))) return

      await _$.sleep(5000)
      const res = await __.media.play(layout_.url.host("/media/digitalsignage/videos/"))
      if (!res) return _$.error("Error handler: failed while trying to play.")

      return true
    },
    checker(timeout = 10000) {
      _$.makeTimeout(async () => {
        const res = await __.api.get.digitalsignage()
        this.signage = Object.assign({}, this.signage || {}, res || this.getSignageModel)

        this.checker()
      }, timeout)

      return true
    },
    reset(type) {
      this.clearTimeouts()
      this.duration = null
      this.signage = Object.assign({}, this.signage, {})

      if (type === "default") __.platform.background().then(() => (this.nolayout = true))

      return true
    },
    init() {
      this.nolayout = false
      this.clearTimeouts()
      const detected = this.detectLayout()
      if (!detected || !detected.layout) return _$.error('No "layouts" detected.')
      if (detected.wait) return _$.sleep(detected.wait * 1000).then(() => this.init())
      return this.initLayout(detected.layout, detected.left)
    },
    async initLayout(layout, duration) {
      if (layout.type === "image") this.playImages(layout)
      else await __.media.play(layout.url.host("/media/digitalsignage/videos/"))

      if (!duration) return true

      const initLayoutTimeout = setTimeout(() => this.init(), duration * 1000)
      this.timeouts.push(initLayoutTimeout)
      return true
    },
    detectLayout() {
      if (this.signage.layouts.length === 1 && this.signage.layouts[0].type === "stream")
        return {
          layout: this.signage.layouts[0],
          left: false,
          wait: false
        }

      this.duration = this.signage.layouts
        .map(_layout => _layout.duration)
        .reduce((acc, curr) => {
          return acc + curr
        })

      let whichLayoutDuration = 0,
        caughtSeconds = Math.round((new Date() - new Date(this.signage.start)) / 1000) % this.duration,
        diff = -1

      const whichLayout = this.signage.layouts.find(layout => {
        whichLayoutDuration += layout.duration
        if (caughtSeconds < whichLayoutDuration) return true
        else return false
      })

      if (!whichLayout) return null
      diff = whichLayoutDuration - caughtSeconds

      return {
        layout: whichLayout,
        left: diff,
        wait: diff <= 5 ? diff : false
      }
    },
    playImages(layout) {
      const images = layout.images.split(",")
      let timeout = 0

      images.forEach(image => {
        const slideTimeout = setTimeout(() => __.platform.background(image.host("/media/digitalsignage/images/")), timeout)
        timeout += layout.per_duration * 1000
        this.timeouts.push(slideTimeout)
      })
    },
    clearTimeouts() {
      if (this.timeouts.length <= 0) return true
      var timeout = this.timeouts.pop()
      clearTimeout(timeout)
    }
  }
}
</script>

<style lang="scss" scoped>
.software {
  position: absolute;
  max-width: 150px;
  top: 25px;
  left: 25px;
}
.company {
  position: absolute;
  max-width: 200px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
